<template>
  <div class="py-4">
    <div v-if="showPrint" id="section-to-print">
      <Voucher
      :voucher="dataPrint.voucher"
      :meta="dataPrint.meta"
      :showqr="1"
      :taxTotal="taxTotal"/>
    </div>
    <div class="container-fluid">
      <form @submit.prevent="searchFilters()" class="card shadow-sm mb-4">
        <div class="card-body">
          <div class="row">
            <b-form-group
              label="Fecha Inicio"
              label-for="input-date-from"
              class="col-12 col-sm-6 col-lg-2">
              <DatePicker
                id="input-date-from"
                v-model="dateFrom"
                :config="optionsFrom"
                placeholder="dd/mm/aaaa"
                @dp-change="onStartChange"
                autocomplete="off"
                required
              ></DatePicker>
            </b-form-group>
            <b-form-group
              label="Fecha Fin"
              label-for="input-date-to"
              class="col-12 col-sm-6 col-lg-2">
              <DatePicker
                id="input-date-to"
                v-model="dateTo"
                :config="optionsTo"
                placeholder="dd/mm/aaaa"
                autocomplete="off"
                required
              ></DatePicker>
            </b-form-group>
            <b-form-group
              v-if="isReportUser"
              label="Documento / Boleta"
              label-for="input-search"
              class="col-12 col-sm-6 col-lg-3">
              <b-form-input
                id="input-search"
                v-model="search"
                placeholder="N° Documento / N° Boleta"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="!isReportUser"
              label="Id Evento"
              label-for="input-search"
              class="col-12 col-sm-6 col-lg-3">
              <b-form-input
                id="input-search"
                v-model.trim="eventId"
                placeholder="Id"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="!isReportUser"
              label="Id Ticket"
              label-for="input-search"
              class="col-12 col-sm-6 col-lg-3">
              <b-form-input
                id="input-search"
                v-model.trim="ticketId"
                placeholder="Nro. transacción"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="!isReportUser"
              label="Email del comprador"
              label-for="input-search"
              class="col-12 col-sm-6 col-lg-3">
              <b-form-input
                id="input-search"
                type="email"
                v-model.trim="userData"
                placeholder="Email del comprador"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="!isReportUser && roleUser"
              label="Email del vendedor"
              label-for="input-search"
              class="col-12 col-sm-6 col-lg-3">
              <b-form-input
                id="input-search"
                type="email"
                v-model.trim="sellerData"
                placeholder="Email del vendedor"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Vendedor"
              label-for="input-seller"
              class="col-12 col-sm-6 col-lg-3"
              v-if="listUser.length > 0 && isReportUser">
              <select class="form-control" v-model="sellerId">
                <option value="">Todos</option>
                <option :value="elem.id" v-for="elem in listUser" :key="elem.id">
                  {{elem.name}}
                </option>
              </select>
            </b-form-group>
            <div class="col-12 col-lg-2">
              <label>&nbsp;</label>
              <div style="display: flex;">
                <button type="submit" class="btn btn-primary btn-block">
                  Buscar
                </button>
                <button class="btn btn-danger" @click="reportExcel()">
                  Exportar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <Loader v-show="loading"></Loader>
      <div v-show="!loading" class="row">
        <div class="col-12">
          <b-card no-body>
            <b-tabs small card>
              <b-tab title="TODAS LAS TRANSACCIONES" active>
                <div class="col-12 table-responsive" >
                  <table id="table1" class="table" style="background: white;">
                    <thead>
                      <tr v-if="isReportUser">
                        <th class="align-middle" scope="col" style="min-width:180px">Fecha</th>
                        <th class="align-middle" scope="col" style="min-width:180px">N° Boleta</th>
                        <th class="align-middle" scope="col" style="min-width:200px">Vendedor</th>
                        <th class="align-middle" scope="col">Documento</th>
                        <th class="align-middle" scope="col">Método Pago</th>
                        <th class="align-middle" scope="col">Cantidad Vendida</th>
                        <th class="align-middle" scope="col">Total</th>
                        <th class="align-middle" scope="col">Estado</th>
                        <th class="align-middle" scope="col" style="min-width:130px">Acciones</th>
                      </tr>
                      <tr v-else>
                        <th class="align-middle" scope="col" style="min-width:120px">Fecha de venta</th>
                        <th class="align-middle" scope="col" style="min-width:180px">Nombre del evento</th>
                        <th class="align-middle" scope="col">ID del evento</th>
                        <th class="align-middle" scope="col">Fecha del evento</th>
                        <!-- <th class="align-middle" scope="col">Email del evento</th> -->
                        <th class="align-middle" scope="col">Email del vendedor</th>
                        <th class="align-middle" scope="col">Email del comprador</th>
                        <th class="align-middle" scope="col">Documento del comprador</th>
                        <th class="align-middle" scope="col">Transacción</th>
                        <th class="align-middle" scope="col">Método de pago</th>
                        <th class="align-middle" scope="col">Tarjeta</th>
                        <th class="align-middle" scope="col">Código de referencia</th>
                        <th class="align-middle" scope="col">Cantidad</th>
                        <th class="align-middle" scope="col">Total</th>
                        <th class="align-middle" scope="col">Estado</th>
                        <th class="align-middle" scope="col" style="min-width:130px">Acciones</th>
                      </tr>
                    </thead>
                    <tbody v-if="itemsTransaction.length > 0 && isReportUser">
                      <tr v-for="item in itemsTransaction" :key="item.transaction">
                        <td>{{item.paymentDate}}</td>
                        <td>{{item.idInvoice}}</td>
                        <td>{{item.sellerName}}</td>
                        <td>{{item.userDocument}}</td>
                        <td>{{item.paymentMethod}}</td>
                        <td class="text-center">{{item.sumQuantity}}</td>
                        <td class="text-right">{{`S/.${item.paymentTotal}`}}</td>
                        <td>
                          <b-badge v-if="item.isAnuled" variant="danger">{{item.state}}</b-badge>
                          <b-badge v-else variant="primary">{{item.state}}</b-badge>
                        </td>
                        <td>
                          <a
                            href="#"
                            @click.prevent="print(item, item.isAnuled)"
                            title="Ver boleta">
                            <i class="material-icons mr-2 text-secondary">visibility</i>
                          </a>
                          <a
                            href="#"
                            @click.prevent="onShowDetail(item)"
                            title="Ver productos">
                            <i class="material-icons mr-2 text-primary">shopping_cart</i>
                          </a>
                          <a
                            href="#"
                            @click.prevent="onCancel(item)"
                            title="Anular transacción"
                            v-if="!item.isAnuled && roleId === 2">
                            <i class="material-icons text-danger">delete</i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="itemsTransaction.length > 0 && !isReportUser">
                      <tr v-for="item in itemsTransaction" :key="item.transaction">
                        <td>{{item.createdDate}}</td>
                        <td>{{item.title}}</td>
                        <td>{{item.activityId}}</td>
                        <td>{{item.date}}</td>
                        <!-- <td>{{item.sellerEmail}}</td> -->
                        <td>{{item.sellerEmail}}</td>
                        <td>{{item.buyerEmail}}</td>
                        <td>{{item.dniUser}}</td>
                        <td>{{item.id}}</td>
                        <td>{{item.paymentMethod}}</td>
                        <td>{{item.cardType}}</td>
                        <td>{{item.paymentInfo}}</td>
                        <td>{{item.sumQuantity}}</td>
                        <td>{{item.paymentTotal}}</td>
                        <td>{{item.state}}</td>
                        <td>
                          <a
                            v-if="roleUser && item.isAnuled == 0 && item.isPayed == 1"
                            href="#"
                            @click.prevent="cancelTransaction(item)"
                            title="Anular transacción"
                            >
                            <i class="material-icons text-danger">delete</i>
                          </a>
                          <a
                            class="ml-3"
                            target="_blank"
                            :href="`${BASE_URL}/ticket-detail/${item.id}/pos/ticket-pos-premium`"
                            title="Ver transacción"
                            >
                            <i v-if="!isSupervisor" class="material-icons text-primary">visibility</i>
                          </a>
                          <button
                            v-if="sendEmailBoxOffice(item.metadata)"
                            @click="modalSendEmail = true; selectedTrx = item"
                            class="ml-3"
                            style="border: none; background: transparent;"
                            title="Enviar entradas"
                          >
                            <i class="material-icons text-primary">email</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="!itemsTransaction.length" class="text-center py-4">
                    <h3>No se encontraron registros</h3>
                  </div>
                </div>
                <div class="overflow-auto mt-3" v-if="pageTransaction.lastPage > 1">
                  <b-pagination
                    v-model="pageTransaction.currentPage"
                    :total-rows="pageTransaction.total"
                    :per-page="pageTransaction.perPage"
                    aria-controls="table1"
                    align="center"
                    @change="pageChange"
                  ></b-pagination>
                </div>
              </b-tab>
              <b-tab title="RECAUDADO POR VENDEDOR">
                <div class="col-12 table-responsive">
                  <table id="table2" class="table" style="background: white;">
                    <thead>
                      <tr>
                        <th class="align-middle" scope="col" style="min-width:200px">Vendedor</th>
                        <th class="align-middle" scope="col">Correo</th>
                        <th class="align-middle" scope="col">Método Pago</th>
                        <th class="align-middle" scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in itemsPaymentMethods" :key="item.transaction">
                        <td>{{item.sellerName}}</td>
                        <td>{{item.sellerEmail}}</td>
                        <td>{{item.paymentMethod}}</td>
                        <td class="text-right">{{`S/.${item.total}`}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="!itemsPaymentMethods.length" class="text-center py-4">
                    <h3>No se encontraron registros</h3>
                  </div>
                  <div class="overflow-auto" v-if="pagePaymentMethods.lastPage > 1">
                    <b-pagination
                      v-model="pagePaymentMethods.currentPage"
                      :total-rows="pagePaymentMethods.total"
                      :per-page="pagePaymentMethods.perPage"
                      aria-controls="table2"
                      @change="pageChangePaymentMethods"
                    ></b-pagination>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>

    <!-- modal confirm cancel -->
    <b-modal
      v-model="modalConfirm"
      hide-header
      cancel-title="Cerrar"
      ok-title="Anular"
      ok-variant="action btn-lg ml-3"
      @ok="handleOk"
    >
      <div class="text-center p-4">
        <p class="lead">
          ¿Estás segur@ que deseas anular esta transacción?
        </p>

        <form ref="form" @submit.stop.prevent="cancelTrans">
          <b-form-group
            class="text-left"
            :state="typeCancelState"
            label="Tipo de anulación"
            label-for="typeCancel"
            invalid-feedback="Tipo de anulación es requerido">
            <b-form-select
              id="typeCancel"
              :state="typeCancelState"
              v-model="typeCancel"
              :options="{ '2': 'Anula usuario', '3': 'Anula estafa',
                '4': 'Anula devolución', '5': 'Posible fraude' }"
              required
            >
            </b-form-select>
          </b-form-group>
          <b-form-group
            :state="typeCancelState"
            label=""
            label-for="textarea-state"
            invalid-feedback="Motivo de la anulación es requerido">
            <b-form-textarea
              id="textarea-state"
              v-model="infoCancel"
              :state="infoCancelState"
              placeholder="Escribe aquí el motivo de la anulación"
              rows="3"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
      </div>
    </b-modal>

    <b-modal
      v-model="modalCancel"
      hide-header
      cancel-title="Cerrar"
      ok-title="Anular"
      ok-variant="action btn-lg ml-3"
      @ok="handleOkCancel"
    >
      <div class="text-center p-3">
        <p class="lead">
          ¿Estás segur@ que deseas anular esta transacción?
        </p>

        <form ref="form" @submit.stop.prevent="onCancelTransaction">
          <b-form-group
          class="mb-1"
            label=""
            label-for="textarea-state"
            invalid-feedback="Motivo de la anulación es requerido">
            <b-form-textarea
              id="textarea-state"
              v-model="reason"
              placeholder="Escribe aquí el motivo de la anulación (obligatorio)"
              maxlength="15"
              rows="1"
              required
            ></b-form-textarea>
          </b-form-group>
          <small>{{ msgCancel }}</small>
        </form>
      </div>
    </b-modal>

    <!-- modal show details -->
    <b-modal
      v-model="modalDetails"
      title="Detalle de la compra"
      hide-footer
      centered
      size="lg"
    >
      <div class="form-group">
        <div class="col-12 table-responsive">
          <table id="table2" class="table" style="background: white;">
            <thead>
              <tr>
                <th scope="col">Nombre del libro</th>
                <th scope="col" class="text-center">Cantidad</th>
                <th scope="col" class="text-right">Precio</th>
                <th scope="col" class="text-right">Subtotal</th>
                <th scope="col" class="text-right">Descuento</th>
                <th scope="col" class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in current.detailsParse" :key="item.name">
                <td>{{item.name}}</td>
                <td class="text-center">{{item.quantity}}</td>
                <td class="text-right">S/.{{item.price}}</td>
                <td class="text-right">S/.{{item.subtotal}}</td>
                <td class="text-right text-danger">
                  <span v-if="item.discount > 0">- S/.{{item.discount}}</span>
                </td>
                <td class="text-right">S/.{{item.total}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="text-right mr-2"><b>Total: </b>S/.{{current.paymentTotal}}</div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="modalSendEmail"
      hide-header
      hide-footer
      @hidden="emailToSend = ''"
    >
      <b-overlay :show="sendingEmail" rounded="sm">
        <div v-if="selectedTrx" class="text-center p-3">
          <p class="lead">
            ¿Se enviarán las entradas al siguiente correo?
          </p>
          <form @submit.stop.prevent="onSendTickets">
            <b-form-group
              v-if="isDummyEmail(selectedTrx.buyerEmail)"
              class="mb-1"
              required>
              <b-form-input
                v-model="emailToSend"
                type="email"
                placeholder="Correo"
                required
              ></b-form-input>
            </b-form-group>
            <p v-else>{{ selectedTrx.buyerEmail }}</p>
            <div class="text-right mt-4" style="border-top: 1px solid #dee2e6; padding-top: 0.75rem;">
              <button type="button" :disabled="sendingEmail" class="btn btn-secondary m-1 ml-2" @click="modalSendEmail = false">Cancelar</button>
              <button type="submit" :disabled="sendingEmail" class="btn btn-primary m-1">Enviar</button>
            </div>
          </form>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import api from '../api';
const { NODE_ENV } = process.env;
const BASE_URL = NODE_ENV === 'development' ? api.baseUrlJn.replace('dev','devpe') : api.baseUrlJn;
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      BASE_URL,
      loading: false,
      list: [],
      modalConfirm: false,
      modalCancel: false,
      modalView: false,
      modalDetails: false,
      dateFrom: new Date(),
      dateTo: new Date(),
      eventId: null,
      userData: null,
      sellerData: null,
      optionsFrom: {
        format: 'YYYY/MM/DD',
        locale: 'es-us',
        useCurrent: false,
        maxDate: moment(),
        icons: {
          time: 'fa fa-clock',
          date: 'fa fa-calendar',
          up: 'fa fa-arrow-up',
          down: 'fa fa-arrow-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calendar-check',
          clear: 'fa fa-trash-alt',
          close: 'fa fa-times-circle',
        },
      },
      optionsTo: {
        format: 'YYYY/MM/DD',
        locale: 'es-us',
        useCurrent: false,
        maxDate: moment(),
        icons: {
          time: 'fa fa-clock',
          date: 'fa fa-calendar',
          up: 'fa fa-arrow-up',
          down: 'fa fa-arrow-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calendar-check',
          clear: 'fa fa-trash-alt',
          close: 'fa fa-times-circle',
        },
      },
      search: '',
      itemsTransaction: [],
      itemsPaymentMethods: [],
      listUser: [],
      sellerId: '',
      infoCancel: '',
      typeCancel: '',
      current: '',
      pageTransaction: {
        perPage: 10,
        currentPage: 1,
        lastPage: 1,
        total: 0,
      },
      pagePaymentMethods: {
        perPage: 10,
        currentPage: 1,
        lastPage: 1,
        total: 0,
      },
      roleId: null,
      dataPrint: {},
      showPrint: false,
      typeCancelState: null,
      infoCancelState: null,
      reason: '',
      msgCancel: '',
      transactionSelected: null,
      isSupervisor: false,
      ticketId: '',
      modalSendEmail: false,
      sendingEmail: false,
      emailToSend: '',
      selectedTrx: null,
    };
  },
  created() {
    if(this.isReportUser){
      this.getReportPaymentMethods();
      this.getItems();
      this.getListUsers();
    } else{
      this.getReportUser();
    }
  },
  mounted() {
    const roles = this.$store.state.auth.roles
    const isSupervisor = roles.find((r) => r.name === 'supervisor_boleteria');
    if (isSupervisor) {
      this.isSupervisor = true
    }
  },
  computed: {
    isReportUser () {
      return this.$route.params.eventId;
    },
    taxTotal() {
      return this.dataPrint.voucher.items.reduce((acc, item) => {
        return acc + parseFloat(item.tax);
      }, 0)
    },
    session() {
      return this.$store.state.auth;
    },
    roleUser() {
      return this.$store.state.auth.roles.some(role => role.name === "supervisor_boleteria");
    }
  },
  methods: {
    async onSendTickets() {
      this.sendingEmail = true;
      const { token } = this.$store.state.auth;
      const payload = {
        type: "seller",
        ticketId: this.selectedTrx.id,
        email: this.isDummyEmail(this.selectedTrx.buyerEmail) ? this.emailToSend : this.selectedTrx.buyerEmail,
      };
      const data = await api.sendTickets(payload, token);
      if (data.status) {
        this.toast({
          title: 'Éxito',
          description: 'Se enviaron correctamente las entradas.',
          variant: 'success',
        })
      } else {
        this.toast({
          title: 'Hubo un error',
          description: data.message || 'No se pudieron enviar los entradas.',
          variant: 'danger',
        })
      }
      this.sendingEmail = false;
      this.modalSendEmail = false;
    },
    async getItems() {
      const { eventId } = this.$route.params;
      this.loading = true;
      const payload = {
        limit: this.pageTransaction.perPage,
        page: this.pageTransaction.currentPage,
        activityId: eventId,
        startDate: this.formatDate(this.dateFrom),
        endDate: this.formatDate(this.dateTo),
        search: this.search,
        sellerId: this.sellerId,
      };
      /* eslint-disable camelcase */
      const {
        data,
        last_page,
        current_page,
        total,
      } = await api.getReportTransaction(payload);
      this.itemsTransaction = data;
      this.pageTransaction.currentPage = current_page;
      this.pageTransaction.lastPage = last_page;
      this.pageTransaction.total = total;
      this.loading = false;
      /* eslint-disable camelcase */
    },
    async getReportPaymentMethods() {
      const { eventId } = this.$route.params;
      const payload = {
        limit: this.pagePaymentMethods.perPage,
        page: this.pagePaymentMethods.currentPage,
        activityId: eventId,
        startDate: this.formatDate(this.dateFrom),
        endDate: this.formatDate(this.dateTo),
        search: this.search,
        sellerId: this.sellerId,
      };

      /* eslint-disable camelcase */
      const {
        data,
        last_page,
        current_page,
        total,
      } = await api.getReportPaymentMethods(payload);
      this.itemsPaymentMethods = data;
      this.pagePaymentMethods.currentPage = current_page;
      this.pagePaymentMethods.lastPage = last_page;
      this.pagePaymentMethods.total = total;
      /* eslint-disable camelcase */
    },
    async getReportUser() {
      try {
        const { token } = this.session;
        const params = {
          perPage: this.pageTransaction.perPage,
          page: this.pageTransaction.currentPage,
          dateStart: this.formatDate(this.dateFrom),
          dateEnd: this.formatDate(this.dateTo),
          search: this.search,
          sellerId: this.sellerId,
          activityId: this.eventId,
          buyerData: this.userData,
          sellerData: this.sellerData,
          ticketId: this.ticketId
        };
        const { data } = await api.getReportUser(token, params);
        const { lastPage, total } = data;
        if(data) {
          this.itemsTransaction = data.items;
          this.pageTransaction.lastPage = lastPage;
          this.pageTransaction.total = total;
        }
        this.msgCancel = "";
      } catch (error) {
        console.log('error', error);
      }
    },
    async reportExcel(){
      const { token } = this.session;
      await api.exportData(token)
    },
    async getListUsers() {
      const { eventId } = this.$route.params;
      const data = await api.getListUsers(eventId);
      this.listUser = data.childrens;
      this.roleId = data.roleId;
    },
    searchFilters() {
    if(this.isReportUser) {
      this.getItems();
      this.getReportPaymentMethods();
    } else {
      this.getReportUser();
    }
    },
    pageChange(page) {
      this.pageTransaction.currentPage = page;
      if(this.isReportUser) {
        this.getItems();
      } else {
        this.getReportUser();
      }
    },
    pageChangePaymentMethods(page) {
      this.pagePaymentMethods.currentPage = page;
      this.getReportPaymentMethods();
    },
    onCancel(item) {
      this.current = item;
      this.modalConfirm = true;
      this.typeCancel = '';
      this.infoCancel = '';
      this.typeCancelState = 1;
      this.infoCancelState = null;
    },
    cancelTransaction(item){
      try {
        this.modalCancel = true;
        this.transactionSelected = item;
      } catch (error) {
        console.log('error', error)
      }
     },
     async onCancelTransaction() {
      const { token } = this.session;
      try {
        if(!this.reason){
          this.msgCancel = "Ingrese la razón de su anulación"
          return;
        }
        await api.annulTransaction(token, this.transactionSelected.id, this.reason);
        this.msgCancel = "Se ha anulado la transacción"
        setTimeout(() => {
          this.modalCancel = false;
          this.reason = "";
        }, 2000);
        this.getReportUser();
      } catch (error) {
        console.log('error', error)
      }
     },
    onShowDetail(item) {
      this.current = item;
      this.current.detailsParse = JSON.parse(item.details);
      this.modalDetails = true;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.typeCancelState = this.typeCancel ? 'valid' : 'invalid';
      this.infoCancelState = this.infoCancel ? 'valid' : 'invalid';
      return valid;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.cancelTrans();
    },
    handleOkCancel(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.onCancelTransaction();
    },
    async cancelTrans() {
      try {
        if (!this.checkFormValidity()) {
          return;
        }
        this.modalConfirm = false;
        const { eventId } = this.$route.params;
        const payload = {
          transaction: {
            code: this.current.code,
          },
          eventId,
          annulment: {
            info: this.infoCancel,
            type: this.typeCancel,
          },
        };
        this.$store.dispatch('changeLoadingJoinnus', true);
        const resp = await api.cancelTransaction(payload);
        if (resp.success) {
          if (resp.voucher) {
            const { voucher } = resp;
            const currency = 'S/.';
            let method = '';
            let methodCard = '';

            if (voucher.methods.efectivo && voucher.methods.pos) {
              method = 'multiple';
              methodCard = voucher.methods.pos.cardType;
              voucher.methods.efectivo.amountReturned = voucher.methods.efectivo.amountReturned
                ? voucher.methods.efectivo.amountReturned : 0;
            } else {
              if (voucher.methods.efectivo && voucher.methods.efectivo.paymentMethod) {
                method = voucher.methods.efectivo.paymentMethod;
                voucher.methods.efectivo.amountReturned = voucher.methods.efectivo.amountReturned
                  ? voucher.methods.efectivo.amountReturned : 0;
              }
              if (voucher.methods.pos && voucher.methods.pos.paymentMethod) {
                method = voucher.methods.pos.paymentMethod;
                methodCard = voucher.methods.pos.cardType;
              }
              if (voucher.methods.qrvisa && voucher.methods.qrvisa.paymentMethod) {
                method = voucher.methods.qrvisa.paymentMethod;
              }
            }

            const result = Object.keys(voucher.items).map(x => (
              parseFloat(voucher.items[x].total, 2))).reduce((a, b) => (a + b));
            voucher.totalAmount = result.toFixed(2);

            const meta = {
              currency,
              method,
              methodCard,
              siteUrl: 'https://www.joinnus.com',
            };

            this.dataPrint = {};
            this.dataPrint.meta = { ...meta };
            this.dataPrint.voucher = { ...voucher };
            this.showPrint = true;
            setTimeout(() => {
              window.print();
            }, 800);
          }

          this.getItems();
          this.getReportPaymentMethods();
        }
      } catch (error) {
        console.error("error =>> ", error);
      } finally{
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    async print(item, isAnuled) {
      try {
        const payload = {
          transactionCode: item.code,
        };
        this.$store.dispatch('changeLoadingJoinnus', true);
        let data = {};
        if (!isAnuled) {
          data = await api.getElectronicBilling(payload);
        } else {
          data = await api.getCreditNote(payload);
        }

        if (!data || !data.methods) {
          return;
        }

        const currency = 'S/.';
        let method = '';
        let methodCard = '';
        if (data.methods.efectivo && data.methods.pos) {
          method = 'multiple';
          methodCard = data.methods.pos.cardType;
          data.methods.efectivo.amountReturned = data.methods.efectivo.amountReturned
            ? data.methods.efectivo.amountReturned : 0;
        } else {
          if (data.methods.efectivo && data.methods.efectivo.paymentMethod) {
            method = data.methods.efectivo.paymentMethod;
            data.methods.efectivo.amountReturned = data.methods.efectivo.amountReturned
              ? data.methods.efectivo.amountReturned : 0;
          }
          if (data.methods.pos && data.methods.pos.paymentMethod) {
            method = data.methods.pos.paymentMethod;
            methodCard = data.methods.pos.cardType;
          }
          if (data.methods.qrvisa && data.methods.qrvisa.paymentMethod) {
            method = data.methods.qrvisa.paymentMethod;
          }
        }

        const result = Object.keys(data.items).map(x => (
          parseFloat(data.items[x].total, 2))).reduce((a, b) => (a + b));
        data.totalAmount = result.toFixed(2);

        const meta = {
          currency,
          method,
          methodCard,
          siteUrl: 'https://www.joinnus.com',
        };

        this.dataPrint = {};
        this.dataPrint.meta = { ...meta };
        this.dataPrint.voucher = { ...data };
        this.showPrint = true;
        setTimeout(() => {
          window.print();
        }, 500);
      } catch (error) {
        console.log("error =>>>", error);
      } finally {
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
      
    },
    onStartChange(e) {
      this.$set(this.optionsTo, 'minDate', e.date || null);
      document.getElementById('input-date-to').focus();
    },
    sendEmailBoxOffice(metadata){
      if (!metadata) return false
      const mail = this.getMetaValue(metadata, 'sendEmailBoxOffice')
      return mail ? true : false
    }
  },
};
</script>
<style>
  .table th{
    border-top: 0 !important;
  }
</style>
